import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  font-family: 'Noto Sans', sans-serif;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Diamont = styled.div`
  bottom: -64px;
  position: absolute;
`;
Diamont.displayName = 'Diamont';

export const Frame = styled.img`
  position: absolute;
`;
Frame.displayName = 'Frame';

export const FrameContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
`;
FrameContainer.displayName = 'FrameContainer';

export const Logo = styled.img`
  bottom: -86px;
  filter: drop-shadow(0px -5px 50px rgba(0, 0, 0, 0.25));
  max-width: 172px;
  position: absolute;
`;
Logo.displayName = 'Logo';

export const Time = styled.div`
  align-items: center;
  background: linear-gradient(261.34deg, #e2e2e4 -0.59%, #e6e6e8 99.5%);
  border: 2px solid #918e9d;
  color: #1b32ff;
  display: flex;
  font-size: 56px;
  font-style: normal;
  font-weight: bold;
  height: 104px;
  justify-content: center;
  letter-spacing: 0.02em;
  line-height: 64px;
  text-align: center;
  text-decoration: inherit;
  width: 263px;
`;
Time.displayName = 'Time';

export const Title = styled.div`
  color: #ffffff;
  font-size: 32px;
  letter-spacing: 0.05em;
  line-height: 40px;
  letter-spacing: 0px;
  margin-bottom: 20px;
  text-align: center;
  white-space: pre-wrap;
`;
Title.displayName = 'Title';
